import { useLinkSource } from '@dsx-react/link';
import { themeColorToCssVariable } from '@dsx-react/theme';
import { useFocus, usePress, classNames } from '@dsx-react/util';
import { jsx } from 'react/jsx-runtime';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Card-module_card__XgCbD {\n  background-color: var(--color-neutral-0);\n  border-radius: var(--UNSAFE-card-border-radius);\n  overflow: hidden;\n  outline: none;\n}\n\n.Card-module_link-card__RHik0 {\n  display: block;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n.Card-module_bleed-default__UBGDF {\n  padding: var(--size-300);\n}\n\n.Card-module_bleed-full__CURCr {\n  padding: 0;\n}\n\n.Card-module_focusable__6OIwq {\n  position: relative;\n  cursor: pointer;\n}\n\n.Card-module_focusable__6OIwq:focus::after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  border: 1px solid var(--color-primary-500);\n  border-radius: var(--UNSAFE-card-border-radius);\n}\n\n.Card-module_shadow__VjHc6 {\n  box-shadow: var(--UNSAFE-card-shadow-box-shadow);\n}\n\n.Card-module_outline__Z-dWy {\n  border: 1px solid;\n}";
var styles = {"card":"Card-module_card__XgCbD","link-card":"Card-module_link-card__RHik0","bleed-default":"Card-module_bleed-default__UBGDF","bleed-full":"Card-module_bleed-full__CURCr","focusable":"Card-module_focusable__6OIwq","shadow":"Card-module_shadow__VjHc6","outline":"Card-module_outline__Z-dWy"};
styleInject(css_248z);

const CardVariantValues = ['shadow', 'outline', 'flat'];
function Card(props) {
  const {
    children,
    variant = 'shadow',
    bleed = 'default',
    onFocus,
    onBlur,
    onPress,
    className: callerClassName,
    href,
    tag,
    outlineColor = 'color-primary-500'
  } = props;
  const {
    Link,
    linkProps
  } = useLinkSource(props);
  const {
    focusProps
  } = useFocus({
    onFocus,
    onBlur
  });
  const {
    pressProps
  } = usePress({
    onPress
  });
  const isInteractive = !!(onFocus || onBlur || onPress || href);
  const className = classNames('dsx-component', styles['card'], styles[`bleed-${bleed}`], styles[variant], isInteractive && styles['focusable'], href && styles['link-card'], callerClassName);
  if (href) {
    return /*#__PURE__*/jsx(Link, {
      ...linkProps,
      className: className,
      "data-dsx--card": tag,
      children: children
    });
  }
  return /*#__PURE__*/jsx("div", {
    ...focusProps,
    ...pressProps,
    className: className,
    tabIndex: isInteractive ? 0 : undefined,
    "data-dsx--card": tag,
    style: {
      borderColor: themeColorToCssVariable(outlineColor)
    },
    children: children
  });
}

export { Card, CardVariantValues };
